import getMeta from '@atlassian/jira-get-meta';
import transformSubProducts from '../transform-sub-products';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => transformSubProducts(getMeta('ajs-application-key'));
